// src/services/toastService.js
import { toast } from 'react-hot-toast';
import { notificationText } from '../utils/notificationText';

export function showNotificationToast(n = {}) {
  return showToast({
    ...n,
    title: notificationText(n.title) || 'Notification',
    message: notificationText(n.message),
  });
}

/** --- Sound config (override anytime with setToastSound) --- */
let ding = new Audio(
  'https://res.cloudinary.com/joegalaxy/video/upload/v1658385502/Whatsapp_Message_-_QuickSounds.com_u2jgir.mp3',
);
ding.preload = 'auto';

/** Prime audio after a user gesture to avoid autoplay blocks */
export function primeToastAudio() {
  try {
    ding
      .play()
      .then(() => ding.pause())
      .catch(() => {});
  } catch {}
}

/** Replace the default sound at runtime (optional) */
export function setToastSound(url) {
  try {
    ding = new Audio(url);
    ding.preload = 'auto';
  } catch {}
}

/**
 * Responsive, all-in-one toaster:
 * - Plays a quick ding if the tab is visible
 * - Mobile: top banner; Desktop: bottom-right card
 * - Optional CTA { url, label }
 * - Optional type: 'message' | 'alert' | 'success' | default
 * - Optional silent: true (skip sound)
 * - Optional vibrate: true (mobile haptics)
 */
export function showToast(n = {}) {
  const isMobile = window.innerWidth <= 768;
  const position = isMobile ? 'top-center' : 'bottom-right';

  // Play sound only if page is visible and not explicitly silenced
  if (!n.silent && !document.hidden) {
    ding?.play?.().catch(() => {});
    // light haptic on supported devices if requested
    if (n.vibrate && navigator.vibrate) navigator.vibrate(20);
  }

  toast.custom(
    (t) => (
      <div
        onClick={() => {
          if (n?.cta?.url) window.location.href = n.cta.url;
          toast.dismiss(t.id);
        }}
        style={{
          cursor: n?.cta?.url ? 'pointer' : 'default',
          width: isMobile ? '95%' : 360,
          maxWidth: '95vw',
          padding: '12px 14px',
          borderRadius: isMobile ? 0 : 12,
          background: getBackgroundColor(n.type),
          color: '#fff',
          border: `1px solid ${getAccent(n.type)}`,
          boxShadow: isMobile
            ? '0 2px 8px rgba(0,0,0,0.15)'
            : '0 10px 30px rgba(0,0,0,0.4)',
          animation: isMobile
            ? 'slideDown 0.28s ease-out'
            : 'slideIn 0.28s ease-out',
          display: 'flex',
          flexDirection: 'column',
          gap: 4,
          zIndex: 9999,
        }}
      >
        <strong style={{ fontSize: 14 }}>{n.title || 'Notification'}</strong>
        {n.message && (
          <span style={{ fontSize: 13, opacity: 0.95 }}>{n.message}</span>
        )}
        {n?.cta?.label && (
          <span
            style={{
              fontSize: 12,
              opacity: 0.85,
              textDecoration: 'underline',
              marginTop: 2,
            }}
          >
            {n.cta.label}
          </span>
        )}
      </div>
    ),
    {
      duration: n.duration ?? 5000,
      position,
      id: n.collapseKey || undefined, // collapse identical toasts if you send a key
    },
  );
}

function getAccent(type) {
  switch (type) {
    case 'message':
      return '#8a2be2'; // purple
    case 'alert':
      return '#e63946'; // red
    case 'success':
      return '#2a9d8f'; // green-teal
    default:
      return '#facc15'; // amber
  }
}
function getBackgroundColor(type) {
  // slightly darker base so the border accent pops
  switch (type) {
    case 'message':
      return '#1a1023';
    case 'alert':
      return '#1f0d10';
    case 'success':
      return '#0f1f1d';
    default:
      return '#111111';
  }
}
